import { SquaredIconButton, css, styled } from '@lux/ds';

export const NavWrapper = styled('div', {
  shouldForwardProp: prop => !['open'].includes(prop as string),
})<{ open: boolean }>(
  ({ theme, open }) => css`
    border-right: 1px solid ${theme.palette.primary.shade[80]};
    width: 60px;
    height: 100%;
    transition: width 0.5s;

    ${open &&
    css`
      width: 286px;
    `}
  `,
);

export const Nav = styled('div')(
  ({ theme }) => css`
    display: grid;
    grid-template-rows: 56px 56px 1fr;
    grid-template-columns: 1fr;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    position: relative;

    .navigation-menu-btn {
      position: absolute;
      top: calc(64px + 8px);
      right: 0px;
      transform: translateX(50%);
      background-color: ${theme.palette.background.default};
      border-radius: 50%;
      z-index: 5;
      box-shadow: 0px 2px 4px rgba(68, 68, 66, 0.32);
      height: 24px;
      width: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      svg {
        font-size: 10px;
        color: ${theme.palette.primary.main};
      }
    }

    .logo-wrapper {
      align-items: center;
      cursor: pointer;
      display: flex;
    }
  `,
);

export const StyledIconButton = styled(SquaredIconButton)(
  ({ theme }) => css`
    border: none;
    color: ${theme.palette.primary.shade[40]};
    width: 40px;
    display: flex;
    justify-content: flex-start;
    gap: ${theme.space.s};
    overflow: hidden;

    g {
      fill: ${theme.palette.primary.shade[40]};
    }
  `,
);

export const StyledLinks = styled('div')<{ open: boolean }>(
  ({ theme, open }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.space.l};
    overflow: auto;

    button {
      transition: width 0.5s;
    }

    ${open &&
    css`
      button {
        width: 228px;
      }
    `}
  `,
);

export const StyledBottomButton = styled('div')<{ open: boolean }>(
  ({ theme, open }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.space.l};
    overflow: hidden;
    margin-bottom: 16px;

    .small-icon-button {
      transition: all 0.5s;
      opacity: 1;
      position: absolute;
      bottom: 0;
    }

    .full-size-button {
      transition: all 0.5s;
      opacity: 0;
    }

    ${open &&
    css`
      .full-size-button {
        width: 228px;
        opacity: 1;
      }

      .small-icon-button {
        display: none;
      }
    `}
  `,
);
